import { FullCenterContentComponent } from 'components/FullCenterContent';
import { MainTemplateComponent } from 'components/MainTemplate';
import { HeaderBarComponent } from 'components/HeaderBar';
import LogoImage from "images/logo.png";
import React from 'react';
import './styles.scss';

export function GenericErrorScreenComponent({
    message = 'Ocorreu um erro inesperado. Por favor volte a tentar.',
    withHeaderBar = true,
    className = '',
    children
}) {
    return (
        <MainTemplateComponent className={`generic-error-screen ${className}`}>

            {!withHeaderBar ? null : (
                <HeaderBarComponent
                    logoPath={LogoImage}
                    hideScore={true}
                />
            )}

            <div className="area-content default-margins">
                {children}

                <FullCenterContentComponent className="fixed">

                    <div style={{ textAlign: 'center' }}>
                        <img src={LogoImage} alt="Orff Hero - 100% Música" />
                        <h2 className="msg">{message}</h2>
                    </div>
                </FullCenterContentComponent>
            </div>

        </MainTemplateComponent>
    );
};